module.exports = __webpack_public_path__ + "img/qac-ac2500g1-4.prt.ba5aab21.jpg";